import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Page} from '../page';
import {PageRequest} from '../page-request';
import {MatSelectChange} from '@angular/material/select';

@Component({
    selector: 'zah-paginator',
    templateUrl: './paginator.component.html',
    styleUrls: ['./paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent {

  @Input()
  currentPage: Page<any>;
  @Input()
  pageSize = 5;
  @Output()
  pageSizeChange: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  pageChange: EventEmitter<PageRequest<any>> = new EventEmitter<PageRequest<any>>();

  onPageSizeChange(selectChange: MatSelectChange): void {
    this.pageSizeChange.emit(selectChange.value);
  }

  onPreviousClick(): void {
    this.pageChange.emit(PageRequest.previousPageRequest(this.currentPage));
  }

  onNextClick(): void {
    this.pageChange.emit(PageRequest.nextPageRequest(this.currentPage));
  }
}
